import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as AutomationService from '@/services/AutomationService';
import type { AutomationConfig } from '@/types/automation';

export const useAutomationConfig = () =>
  useQuery({
    queryKey: ['automation', 'config'],
    queryFn: AutomationService.getAutomationConfig,
  });

export const useUpdateAutomationConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: AutomationConfig) => AutomationService.updateAutomationConfig(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['automation', 'config'] }),
  });
};
